import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Unfinished = ({ id, path}) => {
  return (
    <div className="content questionsArea mock-already-completed mock-container">
      <Row>
        <Col xs={12}>
          <Card.Body>
            <Row className="testFinish unselectable">
              <div className="col-sm-12">
                <p className="mock-resource-text">
                  <span>
                    This mock is unfinished. Mock test Please{" "}
                    <NavLink to={`/admin/${path}`}>
                    <button className="btn">Click here</button>
                    </NavLink>{" "}
                    to resume this test.
                  </span>
                </p>
              </div>
            </Row>
          </Card.Body>
        </Col>
      </Row>
    </div>
  );
};

export default Unfinished;
